import { measure } from "@obs/tokens/index.stylex.ts";
import type { StyleXStyles } from "@stylexjs/stylex";
import * as stylex from "@stylexjs/stylex";

export type LoaderSize = "small" | "medium";

export type LoaderPrimitiveProps = {
	size?: LoaderSize;
	sx?: StyleXStyles;
};

const rotator = stylex.keyframes({
	"0%": { transform: "rotate(0deg)" },
	"100%": { transform: "rotate(270deg)" },
});

const dash = stylex.keyframes({
	"0%": {
		strokeDashoffset: "187",
	},
	"50%": {
		strokeDashoffset: "46.75",
		transform: "rotate(135deg)",
	},
	"100%": {
		strokeDashoffset: "187",
		transform: "rotate(450deg)",
	},
});

const styles = stylex.create({
	container: {
		animationName: rotator,
		animationDuration: "1.4s",
		animationTimingFunction: "linear",
		animationIterationCount: "infinite",
	},
	small: {
		blockSize: measure.sizeIconDefault,
		inlineSize: measure.sizeIconDefault,
	},
	medium: {
		blockSize: measure.sizeIconXl,
		inlineSize: measure.sizeIconXl,
	},
	circle: {
		stroke: "currentColor",
		transformOrigin: "center",
		animationName: dash,
		animationDuration: "1.4s",
		animationTimingFunction: "ease-in-out",
		animationIterationCount: "infinite",
		strokeDasharray: "187",
		strokeDashoffset: "0",
	},
});

export function LoaderPrimitive({ size = "small", sx }: LoaderPrimitiveProps) {
	return (
		<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" {...stylex.props(styles.container, styles[size], sx)}>
			<circle
				{...stylex.props(styles.circle)}
				cx="24"
				cy="24"
				r="20"
				strokeWidth={4}
				strokeLinecap="round"
				fill="none"
			/>
		</svg>
	);
}
